/* eslint-disable import/prefer-default-export */
export const l1Nav = [
  {
    name: 'Top News',
    path: 'https://m.timesofindia.com/',
    isTop: 'true',
    gaLabel: '',
  },
  {
    name: 'TOI+',
    path: 'https://m.timesofindia.com/toi-plus',
    gaLabel: 'toiplus',
    styles: 'toiplus',
  },
  // {
  //   name: 'Budget 2023',
  //   path: 'https://m.timesofindia.com/business/budget',
  //   gaLabel: '',
  //   styles: '',
  // },
  // {
  //   name: 'Gujarat Election Result',
  //   path:
  //     'https://timesofindia.indiatimes.com/india/gujarat-election-results-2022-live-updates-bjp-aap-congress-arvind-kejriwal-gujarat-assembly-election-result/liveblog/96067992.cms',
  //   gaLabel: '',
  // },
  // {
  //   name: 'HP Election Result',
  //   path:
  //     'https://timesofindia.indiatimes.com/india/himachal-pradesh-election-results-2022-live-updates-bjp-congress-hp-assembly-election-result/liveblog/96068462.cms',
  //   gaLabel: '',
  // },
  // {
  //   name: 'Elections 2022',
  //   path: 'https://m.timesofindia.com/elections/assembly-elections',
  //   gaLabel: '',
  // },
  // {
  //   name: 'FIFA World Cup',
  //   path: 'https://m.timesofindia.com/sports/football/fifa-world-cup',
  //   gaLabel: '',
  // },
  {
    name: 'City',
    path: 'https://timesofindia.indiatimes.com/city?cs=t',
    gaLabel: '',
  },
  { name: 'India', path: 'https://m.timesofindia.com/india', gaLabel: '' },
  { name: 'Briefs', path: 'https://m.timesofindia.com/briefs', gaLabel: '' },
  {
    name: 'Entertainment',
    path: 'https://m.timesofindia.com/entertainment',
    gaLabel: '',
  },
  {
    name: 'Property Expo',
    path:
      'https://timesofindia.indiatimes.com/property-expo?utm_source=hp&utm_medium=mweb&utm_campaign=proprty_expo&utm_id=proprty_expo',
    gaLabel: '',
    doNotChangeURL: 'true',
  },
  {
    name: 'Lifestyle',
    path: 'https://m.timesofindia.com/life-style',
    gaLabel: '',
  },
  { name: 'Sports', path: 'https://m.timesofindia.com/sports', gaLabel: '' },
  { name: 'TV', path: 'https://m.timesofindia.com/tv/hindi', gaLabel: '' },
  { name: 'Videos', path: 'https://m.timesofindia.com/videos', gaLabel: '' },
  { name: 'World', path: 'https://m.timesofindia.com/world', gaLabel: '' },
  {
    name: 'Business',
    path: 'https://m.timesofindia.com/business',
    gaLabel: '',
  },
  { name: 'Tech', path: 'https://m.timesofindia.com/tech', gaLabel: '' },
  { name: 'Auto', path: 'https://m.timesofindia.com/auto', gaLabel: '' },
  {
    name: 'Education',
    path: 'https://m.timesofindia.com/education',
    gaLabel: '',
  },
  {
    name: 'Web Stories',
    path: 'https://m.timesofindia.com/etimes/web-stories',
    gaLabel: '',
  },
  // {
  //   name: 'India at 75',
  //   path: 'https://m.timesofindia.com/india-at-75',
  //   gaLabel: '',
  //   styles: 'india75',
  // },
  {
    name: 'Elections 2023',
    path: 'https://m.timesofindia.com/elections',
    gaLabel: '',
    styles: '',
  },
];

export const l1NavVideo = [
  {
    name: 'Top News',
    path: 'https://m.timesofindia.com/',
    gaLabel: '',
  },
  {
    name: 'TOI+',
    path: 'https://m.timesofindia.com/toi-plus',
    gaLabel: 'toiplus',
    styles: 'toiplus',
  },
  {
    name: 'Videos',
    path: 'https://m.timesofindia.com/videos',
    gaLabel: '',
    isTop: 'true',
  },
  {
    name: 'City',
    path: 'https://timesofindia.indiatimes.com/city?cs=t',
    gaLabel: '',
  },
  { name: 'India', path: 'https://m.timesofindia.com/india', gaLabel: '' },
  {
    name: 'Entertainment',
    path: 'https://m.timesofindia.com/entertainment',
    gaLabel: '',
  },
  {
    name: 'TOISA',
    path:
      'https://timesofindia.indiatimes.com/toisa?utm_source=hp&utm_medium=mweb&utm_campaign=toisa&utm_id=toisa',
    gaLabel: '',
  },
  {
    name: 'Lifestyle',
    path: 'https://m.timesofindia.com/life-style',
    gaLabel: '',
  },
  { name: 'Sports', path: 'https://m.timesofindia.com/sports', gaLabel: '' },
  { name: 'TV', path: 'https://m.timesofindia.com/tv/hindi', gaLabel: '' },
  { name: 'World', path: 'https://m.timesofindia.com/world', gaLabel: '' },
  {
    name: 'Business',
    path: 'https://m.timesofindia.com/business',
    gaLabel: '',
  },
  { name: 'Tech', path: 'https://m.timesofindia.com/tech', gaLabel: '' },
  { name: 'Auto', path: 'https://m.timesofindia.com/auto', gaLabel: '' },
  {
    name: 'Education',
    path: 'https://m.timesofindia.com/education',
    gaLabel: '',
  },
  {
    name: 'Web Stories',
    path: 'https://m.timesofindia.com/etimes/web-stories',
    gaLabel: '',
  },
];
export const toiTitle =
  'News - Latest News, Breaking News, Bollywood, Sports, Business and Political News | Times of India';
